import PropTypes from 'prop-types';
import React from 'react';
import PageBlock from 'components/PageBlock';
import { Box, Flex, Heading } from 'roo-ui/components';

const Wrapper = ({ children }) => (
  <PageBlock py={10} px={[4, 6, 0]} data-print-style="page-block">
    <Box bg="white" borderRadius="default" boxShadow="hard" width={[1, 3 / 4, 2 / 3]}>
      <Flex px={[4, 8]} py={4} borderBottom={1} borderColor="greys.alto">
        <Heading.h3 fontWeight="bold" fontSize="md" mb={0} lineHeight="32px" data-testid="title">
          Your enquiry
        </Heading.h3>
      </Flex>

      <Box px={[4, 6]} py={6} data-testid="content">
        {children}
      </Box>
    </Box>
  </PageBlock>
);

Wrapper.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Wrapper;
